import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface AlignmentRowProps {
  name: string;
  time: string;
}

function AlignmentRow({name, time}: AlignmentRowProps): JSX.Element {
  return (
    <>
      <td className="name">
        <div>{name}</div>
      </td>
      <td className="time">
        <div>
          {time}
          <span className="glyphicon glyphicon-trash delete" />
        </div>
      </td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<AlignmentRowProps>(AlignmentRow);
